export const CONTACTS_SEARCH = "CONTACTS_SEARCH";
export const CONTACTS_SEARCH_RESPONSE = "CONTACTS_SEARCH_RESPONSE";
export const CONTACTS_CREATE = "CONTACTS_CREATE";
export const CONTACTS_CREATE_RESPONSE = "CONTACTS_CREATE_RESPONSE";
export const CONTACTS_UPDATE = "CONTACTS_UPDATE";
export const CONTACTS_UPDATE_RESPONSE = "CONTACTS_UPDATE_RESPONSE";
export const CONTACTS_DELETE = "CONTACTS_DELETE";
export const CONTACTS_DELETE_RESPONSE = "CONTACTS_DELETE_RESPONSE";
export const CONTACTS_SEARCH_CELL_CARRIERS = "CONTACTS_SEARCH_CELL_CARRIERS";
export const CONTACTS_SEARCH_CELL_CARRIERS_RESPONSE = "CONTACTS_SEARCH_CELL_CARRIERS_RESPONSE";